import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';
import { objectToFormData } from 'utils/helpers';

export const fetchSettingSystem =
    async () // eslint-disable-next-line @typescript-eslint/no-explicit-any
    : Promise<IBodyResponse<any>> => {
        const response = await axiosInstance.get(
            'admin/setting_systems/detail'
        );
        return response.data;
    };

export const updateSettingSystem = async (
    data: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.put(
        'admin/setting_systems/save',
        objectToFormData(data)
    );
    return response.data;
};

export const planSettingDetail =
    async () // eslint-disable-next-line @typescript-eslint/no-explicit-any
    : Promise<IBodyResponse<any>> => {
        const response = await axiosInstance.get(
            `admin/setting_systems/plan_setting_detail`
        );
        return response.data;
    };

export const surveyServiceDetail =
    async () // eslint-disable-next-line @typescript-eslint/no-explicit-any
    : Promise<IBodyResponse<any>> => {
        const response = await axiosInstance.get(
            `admin/setting_systems/survey_service_detail`
        );
        return response.data;
    };
